/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { AbstractControl, ValidationErrors } from '@angular/forms'
import { parsePhoneNumber } from 'awesome-phonenumber'

// Regex taken from https://emailregex.com/
const EMAIL_REGEX = // eslint-disable-next-line no-useless-escape
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export function emailRfcValidator(control: AbstractControl): ValidationErrors | null {
  return EMAIL_REGEX.test(control.value) ? null : { emailRfc: true }
}

export function mobileValidator(control: AbstractControl): { [key: string]: boolean } | null {
  if (!control.value) {
    return null
  }
  const phoneNumber = parsePhoneNumber(control.value)

  if (!phoneNumber.valid) {
    return { mobile: true }
  }

  if (!phoneNumber.typeIsMobile) {
    return { mobile: true }
  }

  const normalizedInput = control.value.replace(/\s/g, '')
  if (normalizedInput !== phoneNumber.number?.e164) {
    return { mobile: true }
  }

  return null
}

export function dateValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const inputDate = new Date(control.value)

  if (isNaN(inputDate.getTime())) {
    return { invalidDate: true }
  }

  const today = new Date()
  const hundredYearsAgo = new Date(today)
  hundredYearsAgo.setFullYear(today.getFullYear() - 100)

  if (inputDate > today) {
    return { maxDate: true }
  } else if (inputDate < hundredYearsAgo) {
    return { minDate: true }
  }

  return null
}
